module.exports = __webpack_public_path__ + "img/hand-flag.e519f0eb.png";